export default __webpack_public_path__ + "static/media/mitigation-mechanical-room-drying.4a98c07c.jpg";